import styled from 'styled-components'

export const TextContainer = styled.div`
  padding: 20px 30px;
  align-items: center;
  justify-content: center;
  text-align: center;
`
